<div class="parallax_img" id="parallax_img"></div>

<portfolio-navigation></portfolio-navigation>

<main id="main">
    <div class="container coming-soon-container text-center px-md-4">
        <span>IN THE COMMUNITY</span>
        <!-- <p class="mt-4 mb-5 p-0">A learning portfolio. Designed for you. Game-changing.</p> -->
        <!-- <img class="img-fluid" src="../../../../assets/images/backgrounds/coming-soon.jpg"> -->
    </div>
    <section id="module" class="module">
        <div class="container p-5 mt-5">
            <div data-aos="fade-up">
                <div class="row module-container justify-content-center" data-aos="fade-up" data-aos-delay="200">
                    <div *ngFor="let resource of resources" class="col-md-6 col-lg-6 col-xl-4 module-item">
                        <!-- PDF & Articles -->
                        <a (click)="saveResourcePoints(resource.id, resource.file_type)" *ngIf="resource.file_type === 'pdf' || resource.file_type === 'article'" [href]="resource.link_url" target="_blank">
                            <div class="module-wrap">
                                <div class="d-flex justify-content-center align-item-center">
                                    <img
                                        [defaultImage]="preloaderImage"
                                        [lazyLoad]="resource.image_url"
                                        class="module-image"
                                        [id]="'module_image_' + resource.id"
                                        (onStateChange)="moduleImageCallback($event, resource.id)"
                                    >
                                </div>
                                <div
                                    class="badge-points d-none py-1 px-2"
                                    [id]="'module_badge_points_' + resource.id"
                                >
                                    <img class="module-badge-icon" src="../../../../../../assets/images/icons/award.svg">
                                    <span class="d-inline-block align-middle ml-1 ml-md-1 badge-text">{{ resource.points }} points</span>
                                </div>
                                <div class="module-info">
                                    <h4>{{ resource.title }}</h4>
                                </div>
                            </div>
                        </a>

                        <!-- Video Types -->
                        <a (click)="saveResourcePoints(resource.id, resource.file_type)" *ngIf="resource.file_type === 'video'">
                            <div class="module-wrap">
                                <div class="d-flex justify-content-center align-item-center">
                                    <img
                                        [defaultImage]="preloaderImage"
                                        [lazyLoad]="resource.image_url"
                                        class="module-image"
                                        [id]="'module_image_' + resource.id"
                                        (onStateChange)="moduleImageCallback($event, resource.id)"
                                    >
                                </div>
                                <div
                                    class="badge-points d-none py-1 px-2"
                                    [id]="'module_badge_points_' + resource.id"
                                >
                                    <img class="module-badge-icon" src="../../../../../../assets/images/icons/award.svg">
                                    <span class="d-inline-block align-middle ml-1 ml-md-1 badge-text">{{ resource.points }} points</span>
                                </div>
                                <div class="module-info">
                                    <h4>{{ resource.title }}</h4>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>

        </div>

        <!-- Modal Loader -->
        <modal-loader [modalText]="modalText"></modal-loader>

    </section>
</main>
